const ROOT = 'dashboard/settings/owners/domus/'

export default {
	show: `${ROOT}show-on-domus/`
}
